(function($){

function initPlayer(id_video, id_player, data){

	var player_data, fixFlash_mp4, fixFlash_mp4_id, ignore_timeupdate;

	var options = {
		ready: function () {
			$(this).jPlayer('setMedia', data.media);
		},
		timeupdate: function(event) {
			if(!ignore_timeupdate) {
				control.progress.slider('value', event.jPlayer.status.currentPercentAbsolute);
			}
		},
		volumechange: function(event) {
			if(event.jPlayer.options.muted) {
				control.volume.slider('value', 0);
			} else {
				control.volume.slider('value', event.jPlayer.options.volume);
			}
		},
		play: function(){
			$(id_player+' .jp-video-play-icon').remove();
			$(id_player).unbind('click.play');
			$(id_player).bind('click.pause', function(){
				$(id_player).jPlayer('pause');
			});
			$(this).jPlayer('pauseOthers');
		},
		pause: function(){
			$(id_player).append('<div class="jp-video-play-icon"></div>');
			$(id_player).unbind('click.pause');
			$(id_player).bind('click.play', function(){
				$(id_player).jPlayer('play');
			});
		},
        ended: function() {
            $(this).jPlayer('setMedia', data.media)
        },
		swfPath: 'js',
		supplied: $(id_video).data('supplied'),
		size: {
			width: data.size.width,
			height: data.size.height,
			cssClass: ''
		},
		cssSelectorAncestor: id_video,
		useStateClassSkin: true,
		autoBlur: false,
		smoothPlayBar: true,
		keyEnabled: true,
		remainingDuration: false,
		toggleDuration: true,
		volume: .5
	};

	var control = {
		progress: $(id_video+' .jp-progress-slider'),
		volume: $(id_video+' .jp-volume-slider')
	};

	$(id_player).jPlayer(options);

	player_data = $(id_player).data('jPlayer');

	control.progress.slider({
		animate: 'fast',
		max: 100,
		range: 'min',
		step: 0.1,
		value: 0,
		slide: function(event, ui) {
			var sp = player_data.status.seekPercent;
			if(sp > 0) {
				if(fixFlash_mp4) {
					ignore_timeupdate = true;
					clearTimeout(fixFlash_mp4_id);
					fixFlash_mp4_id = setTimeout(function() {
						ignore_timeupdate = false;
					}, 1000);
				}
				$(id_player).jPlayer('playHead', ui.value * (100 / sp));
			} else {
				setTimeout(function() {
					control.progress.slider('value', 0);
				}, 0);
			}
		}
	});

	control.volume.slider({
		orientation: 'vertical', 
		animate: 'fast',
		max: 1,
		range: 'min',
		step: 0.01,
		value: .5,
		slide: function(event, ui) {
			$(id_player).jPlayer('option', 'muted', false);
			$(id_player).jPlayer('option', 'volume', ui.value);
		}
	});

	$(id_video).hover(function(){
		$(this).find('.jp-interface').fadeIn();
	}, function(){
		$(this).find('.jp-interface').fadeOut();
	});

	$(id_video).find('.jp-volume-controls').hover(function(){
		$(this).find('.jp-volume-box').fadeIn();
	}, function(){
		$(this).find('.jp-volume-box').fadeOut();
	});

}

$.fn.videoPlayer = function(){

	var id_video = '#'+$(this).attr('id');
	var id_player = '#'+$(this).find('.jp-jplayer').attr('id');

    try {
        var data = $.parseJSON($(this).find('.data').text())
    } catch (error) {
    	console.log('JSON parse error!!!');
    	var data = ''
    }

	$(this).append(
		'<div class="jp-gui">'+
			'<div class="jp-video-play">'+
				'<div class="jp-video-play-icon"></div>'+
			'</div>'+
			'<div class="jp-interface">'+
				'<div class="jp-controls">'+
					'<div class="jp-play"></div>'+
				'</div>'+
				'<div class="jp-progress-slider"></div>'+
				'<div class="jp-current-time"></div>'+
				'<div class="jp-duration"></div>'+
				'<div class="jp-volume-controls">'+
					'<div class="jp-volume-bt"></div>'+
					'<div class="jp-volume-box">'+
						'<div class="jp-volume-slider"></div>'+
					'</div>'+
				'</div>'+
				'<div class="jp-full-screen"></div>'+
			'</div>'+
		'</div>'+
		'<div class="jp-no-solution">'+
			'<span>Update Required</span>'+
			'To play the media you will need to either update your browser to a recent version or update your <a href="http://get.adobe.com/flashplayer/" target="_blank">Flash plugin</a>.'+
		'</div>'
		);

	initPlayer(id_video, id_player, data);
}

})(jQuery);